/**
 * @typedef {Player~parameters} SWFPlayer~parameters
 *
 * @property flashWindowMode
 * @property requiredFlashVersion
 *
 * @property gameUrl
 * @property preloaderPath
 * @property gamePath
 * @property coverPath
 */

/**
 * @type {Player}
 */
var SWFPlayer = (function ($, swfobject) {

    /**
     * @param {SWFPlayer~parameters} parameters
     * @param flashVars
     * @param {Player~onEmbed} onEmbed
     */
    function embed(parameters, flashVars, onEmbed) {

        var requiredFlashVersion = parameters.requiredFlashVersion || '25.0';

        if (swfobject.getFlashPlayerVersion().major === 0) {
            onEmbed({
                title: L10N.getString('ERROR_FLASH_DISABLED_TITLE'),
                message: L10N.getString('ERROR_FLASH_DISABLED_MSG'),
                actions: {
                    ACTION_ENABLE_FP: function () {
                        window.top.location = location.protocol + '//get.adobe.com/flashplayer/'
                    }
                },
                isEnableFlash: true
            }, null);
            return;
        }

        if (!swfobject.hasFlashPlayerVersion(requiredFlashVersion)) {
            onEmbed({
                title: L10N.getString('ERROR_REQUIRED_FP_VER_TITLE'),
                message: L10N.getString('ERROR_REQUIRED_FP_VER_MSG') + ' ' + requiredFlashVersion,
                actions: {
                    ACTION_UPDATE_FP: function () {
                        window.top.location = location.protocol + '//get.adobe.com/flashplayer/'
                    }
                }
            }, null);
            return;
        }

        var preloaderUrl = parameters.gameUrl + parameters.preloaderPath;

        var playerElementId = parameters.playerElementId;

        var options = {};
        options.allowScriptAccess = 'always';
        options.allowNetworking = 'all';
        options.allowFullscreen = 'true';
        options.wmode = parameters.flashWindowMode || 'direct';

        var escapedFlashVars = {};
        for (var key in flashVars) {
            if (!flashVars.hasOwnProperty(key)) {
                continue;
            }
            escapedFlashVars[key] = encodeURIComponent(flashVars[key]);
        }

        swfobject.embedSWF(
            preloaderUrl, playerElementId,
            '100%', '100%',
            requiredFlashVersion, 'expressinstall.swf',
            escapedFlashVars, options,
            /* attObj */ null,
            function (event) {
                if (event.success) {
                    onEmbed(null, event.ref);
                } else {
                    onEmbed({message: 'Embed failed'}, null);
                }
            }
        );
    }

    /**
     * @param {String} id
     */
    function getById(id) {
        return swfobject.getObjectById(id);
    }

    // noinspection JSUnusedGlobalSymbols getById is used in ExternalInterfaceServer
    return {
        name: 'SWFPlayer',
        embed: embed,
        getById: getById
    }

})(jQuery, swfobject);
